import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
export function getFullPublicUrl(overrideConfig = {}) {
  return getFullUrl('ecosystem', Object.assign({}, overrideConfig, {
    hubletOverride: 'na1'
  }));
}
export function getPublicLocalizedPathname(lang) {
  switch (lang) {
    case 'pt':
    case 'pt-br':
      return '/pt';
    case 'zh':
    case 'zh-tw':
      return '/zh-tw';
    case 'no':
    case 'no-no':
      return '/no';
    case 'da':
    case 'de':
    case 'es':
    case 'fi':
    case 'fr':
    case 'it':
    case 'ja':
    case 'ko':
    case 'nl':
    case 'pl':
    case 'sv':
    case 'th':
    case 'zh-cn':
      return `/${lang}`;
    default:
      return '';
  }
}

// TODO add nl and it once supported
export const getLocalizedHubSpotUrl = (lang, subdomain = 'www') => {
  switch (lang) {
    case 'de':
    case 'es':
    case 'fr':
      return `https://${subdomain}.hubspot.${lang}`;
    case 'ja':
      return `https://${subdomain}.hubspot.jp`;
    case 'pt':
      return 'https://br.hubspot.com';
    default:
      return `https://${subdomain}.hubspot.com`;
  }
};
const tierGroupPricingPath = {
  CRM: '/crm',
  MARKETING: '/marketing',
  SALES: '/sales',
  SERVICE: '/service',
  CMS: '/content',
  CONTENT: '/content',
  OPERATIONS: '/operations',
  OPS: '/operations' // Remove once backend changes plans to use "OPERATIONS_" prefix
};
export const getTierGroupPricingPath = tierGroup => {
  return tierGroupPricingPath[tierGroup] || '';
};
export const getPricingUrl = (isPublic, hub, lang = 'en', upgradeSource = 'marketplace-ui-core') => {
  let path = getTierGroupPricingPath(hub);
  if (path === '') {
    if (hub.includes('marketing-hub')) {
      path = '/marketing';
    } else if (hub.includes('sales-hub')) {
      path = '/sales';
    } else if (hub.includes('service-hub')) {
      path = '/service';
    } else if (hub.includes('cms-hub')) {
      path = '/cms';
    } else if (hub.includes('content-hub')) {
      path = '/content';
    } else if (hub.includes('operations-hub')) {
      path = '/operations';
    } else if (hub.includes('ops-hub')) {
      path = '/operations';
    }
  }
  if (isPublic) {
    return `${getLocalizedHubSpotUrl(lang)}/pricing${path}?upgradeSource=${upgradeSource}`;
  }
  return `${getFullUrl('app')}/pricing/${PortalIdParser.get()}${path}?upgradeSource=${upgradeSource}`;
};
const getFullInAppMarketplaceUrl = pathname => {
  return `${getFullUrl('app')}/ecosystem/${PortalIdParser.get()}/marketplace/${pathname}`;
};
export const getTemplateMarketplaceUrl = () => getFullInAppMarketplaceUrl('templates');
export const getAppMarketplaceUrl = () => getFullInAppMarketplaceUrl('apps');
export const getSolutionsDirectoryUrl = () => getFullInAppMarketplaceUrl('solutions');
export const getIsLocalDevelopment = () => window.location.hostname.includes('local');